const edu = {
 "about": {
  "whatH": "Was es ist",
  "whatB": "FluentLoop für Bildung bietet Lehrkräften und Schülerinnen und Schülern einer Schule das KI-Sprachtraining von GetFluentLoop – dazu Klassen und Aufgaben für Lehrkräfte.",
  "pilotH": "Das Pilotprogramm",
  "pilotB": "Verifizierte Schulen erhalten ein kostenloses 90-tägiges Pilotprogramm. Ohne Kreditkarte, und es wird nie von selbst zu einem kostenpflichtigen Tarif.",
  "whoH": "Für wen",
  "whoB": "Schulen, Hochschulen, Sprachschulen und andere Bildungseinrichtungen – beantragt von einer Lehrkraft oder der Schulleitung.",
  "getH": "Was Sie bekommen",
  "getB": "Klassen mit Beitrittslinks, Missionen und Aufgaben sowie Übersichten zum Klassenfortschritt für Lehrkräfte.",
  "privacyH": "Datenschutz",
  "privacyB": "Lehrkräfte sehen nur die Arbeit in der Klasse. Persönliche Fluent-Friend-Gespräche, Tagebücher und der private Lernverlauf der Schülerinnen und Schüler bleiben privat. Wir speichern nie Rohfotos oder Sprachaufnahmen.",
  "howH": "So funktioniert es",
  "howB": "Bewerben Sie sich unten. Unser Team prüft jede Bewerbung; das Absenden ist eine Anfrage, keine automatische Freigabe. Den Status sehen Sie hier."
 },
 "publicSub": "Ein kostenloses 90-tägiges Pilotprogramm für verifizierte Schulen.",
 "signupCta": "Konto erstellen und bewerben",
 "signinCta": "Anmelden",
 "returnHint": "Nach der Anmeldung kommen Sie direkt hierher zurück, um sich zu bewerben.",
 "intro": "Geben Sie Ihren Schülerinnen und Schülern ein ganzes Halbjahr KI-gestütztes Sprechtraining – kostenlos für verifizierte Schulen, ohne Kreditkarte.",
 "status": {
  "pending_review": "In Prüfung",
  "needs_information": "Weitere Informationen angefordert",
  "approved": "Genehmigt",
  "rejected": "Nicht genehmigt"
 },
 "approvedLine": "Ihre Schule hat jetzt Zugang zu FluentLoop Education. Viel Freude!",
 "teacherLink": "Lehrkräfte-Dashboard öffnen →",
 "reviewerNote": "Hinweis der Prüfung: {note}",
 "submittedOn": "Eingereicht am {date}. Eine Bewerbung ist eine Anfrage – keine automatische Freigabe.",
 "rejectedDefault": "Die Bewerbung Ihrer Schule wurde derzeit nicht genehmigt.",
 "resubmit": "Sie können unten eine neue Bewerbung einreichen.",
 "f": {
  "name": "Name der Einrichtung *",
  "type": "Art der Einrichtung",
  "country": "Land",
  "website": "Website der Einrichtung",
  "email": "Ihre Schul- / Arbeits-E-Mail",
  "role": "Ihre Rolle",
  "learners": "Ungefähre Anzahl der Lernenden",
  "notes": "Kurze Notiz (optional)",
  "notesPh": "Erzählen Sie uns ein wenig über Ihr Programm.",
  "disclaimer": "Keine Kreditkarte nötig. Wir erheben nie Daten über Schülerinnen und Schüler. Das Absenden ist eine Bewerbung, die unser Team prüft – keine automatische Freigabe."
 },
 "types": {
  "school": "Schule",
  "university": "Hochschule / Universität",
  "language_school": "Sprachschule",
  "training_center": "Bildungszentrum",
  "educational_nonprofit": "Gemeinnützige Bildungsorganisation",
  "other_education": "Andere Bildungseinrichtung"
 },
 "roles": {
  "teacher": "Lehrkraft",
  "school_admin": "Schulverwaltung",
  "principal": "Schulleitung",
  "director": "Direktor/in",
  "coordinator": "Koordination",
  "other": "Andere"
 },
 "toast": {
  "needName": "Bitte geben Sie den Namen Ihrer Einrichtung ein.",
  "alreadyOpen": "Sie haben bereits eine Bewerbung in Prüfung.",
  "submitted": "Bewerbung eingereicht!",
  "failed": "Bewerbung konnte nicht gesendet werden."
 },
 "attest": "Ich bestätige, dass ich mich in meiner beruflichen Rolle als Lehrkraft oder als autorisierte Vertretung der Schule bewerbe.",
 "attestNeeded": "Bitte bestätigen Sie die Erklärung als Lehrkraft.",
 "vTitle": "Wir brauchen noch ein paar Informationen",
 "vIntro": "Um Ihre Rolle an der Schule zu bestätigen, senden Sie uns bitte:",
 "proofs": {
  "institutional_email": "Ihre dienstliche (Schul-)E-Mail-Adresse",
  "staff_page": "Einen Link zu einer offiziellen Kollegiumsseite, auf der Sie stehen",
  "school_admin_confirmation": "Eine Bestätigung Ihrer Schulleitung oder -verwaltung",
  "other": "Einen anderen Nachweis Ihrer Zugehörigkeit zur Schule"
 },
 "vEmail": "Dienstliche E-Mail",
 "vEmailHint": "Nur als Nachweis verwendet. Ihre Anmelde-E-Mail ändert sich nicht.",
 "vUrl": "Link zur offiziellen Kollegiumsseite",
 "vNote": "Kurze Notiz",
 "vSend": "Informationen senden",
 "vReceived": "Danke – wir haben Ihre Informationen erhalten. Ihre Bewerbung ist weiterhin in Prüfung.",
 "vSent": "Informationen gesendet.",
 "vFailed": "Ihre Informationen konnten nicht gesendet werden.",
 "ev": {
  "submitted": "Bewerbung eingereicht",
  "requested": "Weitere Informationen angefordert",
  "response": "Informationen eingegangen"
 }
};
Object.assign(edu, {
 "approvedOnly": "Genehmigt am {date}",
 "approvedActive": "Genehmigt am {date} · Schulpilot aktiv bis {end}",
 "approvedEnded": "Genehmigt am {date} · Schulpilot endete am {end}",
 "teach": {
  "welcome": "Willkommen bei FluentLoop for Education",
  "pilotActive": "Education-Pilot aktiv · Endet am {date}",
  "pilotEnded": "Education-Pilot endete am {date}",
  "pilotInactive": "Education-Pilot nicht aktiv",
  "next": "Legen Sie zuerst eine Klasse für die Sprache an, die Sie unterrichten. Sie erhalten einen Code und einen Link für Ihre Lernenden.",
  "createFirst": "Erste Klasse anlegen",
  "howLink": "So funktioniert FluentLoop for Education",
  "s1H": "Klasse anlegen", "s1B": "Sprache und Niveau wählen.",
  "s2H": "Lernende einladen", "s2B": "Teilen Sie den Klassencode oder Link. Lernende treten mit ihrem eigenen Konto bei.",
  "s3H": "Aufgaben stellen und unterrichten", "s3B": "Erstellen Sie Fluency Missions und weisen Sie sie Ihrer Klasse zu.",
  "s4H": "Klassenfortschritt verfolgen", "s4B": "Sehen Sie erledigte Aufgaben und die Aktivität der Klasse.",
  "canSeeH": "Was Lehrkräfte sehen",
  "canSee": "Wer in der Klasse ist|Erledigte zugewiesene Aufgaben|Schul- und Klassenaktivität|Ergebnisse Ihrer Lektionen und Aufgaben",
  "cantSeeH": "Was Lehrkräfte nicht sehen",
  "cantSee": "Private Fluent-Friend-Gespräche|Journal|Private Lernnachweise|Persönliches Interviewtraining|Persönliches Lernen ohne Bezug zur Klasse",
  "learnMore": "Mehr über FluentLoop for Education",
  "missionLibrary": "Missionsbibliothek",
  "createBtn": "Klasse anlegen",
  "cancel": "Abbrechen",
  "newClass": "Neue Klasse",
  "name": "Klassenname",
  "namePh": "z. B. Spanisch A1 — Gruppe 2",
  "lang": "Zu lernende Sprache",
  "level": "Niveau (GER)",
  "desc": "Beschreibung (optional)",
  "needOrg": "Sie brauchen eine Schule, um eine Klasse anzulegen.",
  "needName": "Bitte geben Sie einen Klassennamen ein.",
  "created": "Klasse angelegt",
  "failed": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  "activeClasses": "Aktive Klassen",
  "activeStudents": "Aktive Lernende",
  "schools": "Schulen",
  "noClasses": "Noch keine aktiven Klassen.",
  "students": {"one": "{count} Lernende:r", "other": "{count} Lernende"},
  "code": "Code",
  "archived": "Archiviert",
  "notTeacher": "Sie sind noch keiner Schule als Lehrkraft zugeordnet.",
  "apply": "Bewerben Sie sich über FluentLoop for Education",
  "requestContinuation": "Verlängerung anfragen",
  "continuationPending": "Verlängerung angefragt",
  "continuationSent": "Verlängerung angefragt. Unser Team prüft sie."
 },
 "cls": {
  "expiredH": "Education-Pilot abgelaufen",
  "expiredB": "Bestehende Klassen und zugewiesene Aufgaben bleiben verfügbar, aber neue Schularbeit kann erst nach einer Verlängerung des Education-Zugangs erstellt werden.",
  "studentExpired": "Der Education-Zugang dieser Schule ist beendet, daher können gerade keine neuen Lernenden beitreten. Ihr persönliches FluentLoop-Konto ist davon nicht betroffen.",
  "archive": "Archivieren", "restore": "Wiederherstellen",
  "invite": "Lernende einladen", "classCode": "Klassencode",
  "copyCode": "Code kopieren", "newCode": "Neuer Code", "copyLink": "Einladungslink kopieren", "newLink": "Neuer Link",
  "showQr": "QR-Code anzeigen", "hideQr": "QR-Code ausblenden", "qrAlt": "QR-Code für den Einladungslink der Klasse",
  "qrNote": "Lernende können ihn scannen, um den Einladungslink zu öffnen. Er wird auf diesem Gerät erzeugt.",
  "codeCopied": "Code kopiert", "linkCopied": "Link kopiert", "regenerated": "Neu erstellt",
  "removed": "Aus der Klasse entfernt", "remove": "Aus der Klasse entfernen",
  "progressFailed": "Fortschritt konnte nicht geladen werden.", "resultsFailed": "Ergebnisse konnten nicht geladen werden.",
  "noAccess": "Sie haben keinen Zugriff auf diese Klasse.",
  "roster": "Klassenliste ({n})", "noStudents": "Noch keine Lernenden. Teilen Sie den Code oder Link oben.", "joined": "Beigetreten am {date}",
  "progress": "Fortschritt",
  "privacyNote": "Nur Klassenarbeit. Persönliches Lernen (Friend, Journal, privater Wortschatz) wird nie angezeigt.",
  "aCompleted": "Erledigte Aufgaben", "inProgress": "In Bearbeitung", "notStarted": "Nicht begonnen", "completed": "Erledigt",
  "lastActivity": "Letzte Klassenaktivität", "late": "(verspätet)",
  "assignments": "Aufgaben", "createMission": "Mission erstellen",
  "noAssignments": "Noch keine Missionen zugewiesen. Erstellen Sie eine Fluency Mission, damit Ihre Klasse übt.",
  "minutes": "~{n} Min.", "due": {"overdue": "überfällig", "due_today": "heute fällig", "due_soon": "bald fällig"},
  "completedLower": "erledigt",
  "insights": "Klassenüberblick", "completionRate": "Abschlussquote", "participation": "Beteiligung",
  "assignedWords": "Zugewiesene Wörter, die die Klasse noch übt", "needPractice": "Missionen, die mehr Übung brauchen könnten",
  "pctDone": "{n} % erledigt", "close": "Schließen", "noStudentsInClass": "Noch keine Lernenden in dieser Klasse.",
  "joinTitle": "Einer Klasse beitreten", "joinAuth": "Melden Sie sich an oder erstellen Sie Ihr kostenloses FluentLoop-Konto, um dieser Klasse beizutreten.",
  "continue": "Weiter", "joinInvalid": "Diese Einladung ist ungültig oder nicht mehr aktiv.",
  "joinBtn": "Dieser Klasse beitreten", "joining": "Beitritt läuft…", "joinedToast": "Sie sind der Klasse beigetreten!", "joinFailed": "Beitritt nicht möglich."
 },
 "stu": {
  "intro": "Ihre Schulklassen. Ihr persönliches Lernen in FluentLoop bleibt getrennt und privat.",
  "none": "Sie sind noch in keiner Klasse.",
  "unfinished": "{n} offen", "completedN": "{n} erledigt", "pilotEndedTag": "Pilot beendet",
  "pilotEnded": "Der FluentLoop-Education-Pilot Ihrer Schule ist beendet. Ihr persönliches FluentLoop-Konto bleibt unverändert.",
  "haveCode": "Haben Sie einen Klassencode?", "joinWithCode": "Haben Sie einen Klassencode? Einer Klasse beitreten",
  "continue": "Weiter", "start": "Starten", "teacher": "Lehrkraft",
  "assignments": "Aufgaben", "noAssignments": "Noch keine Aufgaben.",
  "status": {"not_started": "Nicht begonnen", "in_progress": "In Bearbeitung", "completed": "Erledigt"},
  "due": "Fällig am {date}", "classVocab": "Klassenwortschatz",
  "privacy": "Ihre Lehrkraft sieht nur Ihre Arbeit in dieser Klasse. Ihr persönliches Lernen in FluentLoop bleibt privat.",
  "pendingCount": {"one": "{count} Schulaufgabe offen", "other": "{count} Schulaufgaben offen"},
  "signIn": "Zum Beitreten anmelden", "signUp": "Kostenloses Konto erstellen",
  "codeInvalid": "Dieser Klassencode ist ungültig. Bitte prüfen Sie ihn mit Ihrer Lehrkraft.",
  "tooMany": "Zu viele Versuche. Bitte warten Sie eine Minute und versuchen Sie es erneut.", "tryAgain": "Anderen Code versuchen"
 },
 "faq": {
  "title": "Fragen und Antworten zu Education",
  "g": {"schools": "Für Schulen und Lehrkräfte", "privacy": "Datenschutz und Daten", "students": "Für Lernende", "pilot": "Pilot und Ablauf"},
  "what": {"q": "Was ist FluentLoop for Education?", "a": "Ein Weg für Schulen, FluentLoop mit ihren Klassen zu nutzen. Lehrkräfte legen Klassen an, weisen Fluency Missions zu und verfolgen den Klassenfortschritt, während alle Lernenden ihr eigenes privates FluentLoop-Konto behalten."},
  "pilot90": {"q": "Wie funktioniert der 90-tägige Schulpilot?", "a": "Nach der Genehmigung erhält Ihre Schule 90 Tage FluentLoop Education kostenlos. Lehrkräfte und eingeschriebene Lernende haben während des Pilots Education-Zugang."},
  "whoApply": {"q": "Wer kann sich bewerben?", "a": "Lehrkräfte und autorisiertes Schulpersonal von Schulen, Hochschulen, Sprachschulen und anderen Bildungseinrichtungen."},
  "verified": {"q": "Wie werden Lehrkräfte verifiziert?", "a": "Unser Team prüft jede Bewerbung. Vor der Genehmigung können wir eine dienstliche E-Mail-Adresse oder einen Link zu einer offiziellen Personalseite der Schule anfragen. Niemand wird automatisch genehmigt."},
  "createClass": {"q": "Wie lege ich eine Klasse an?", "a": "Öffnen Sie das Lehrkräfte-Dashboard, wählen Sie Klasse anlegen und geben Sie Klassennamen, Sprache und Niveau ein."},
  "studentsJoin": {"q": "Wie treten Lernende bei?", "a": "Teilen Sie den 6-stelligen Klassencode, den Einladungslink oder den QR-Code. Lernende melden sich mit ihrem eigenen FluentLoop-Konto an und bestätigen die Klasse."},
  "roles": {"q": "Was ist der Unterschied zwischen Lehrkraft und Schuladministration?", "a": "Lehrkräfte führen ihre eigenen Klassen. Die Schuladministration kann zusätzlich alle Klassen der Schule verwalten und eine Verlängerung des Pilots anfragen."},
  "continuation": {"q": "Wie frage ich eine Verlängerung des Pilots an?", "a": "Gegen Ende des Pilots kann die Schuladministration im Lehrkräfte-Dashboard Verlängerung anfragen wählen. Unser Team prüft jede Anfrage."},
  "teacherSee": {"q": "Was sehen Lehrkräfte über Lernende?", "a": "Wer in der Klasse ist, den Fortschritt bei in der Klasse zugewiesener Arbeit, die Klassenaktivität sowie Ergebnisse ihrer eigenen Lektionen und Aufgaben."},
  "teacherCant": {"q": "Was sehen Lehrkräfte nicht?", "a": "Nichts aus dem persönlichen Lernen in FluentLoop: keine Fluent-Friend-Gespräche, kein Journal, keine privaten Lernnachweise, keinen persönlichen Wortschatz, kein persönliches Interviewtraining und keinen Übungsverlauf ohne Bezug zur Klasse."},
  "friendJournal": {"q": "Können Lehrkräfte Fluent-Friend-Gespräche oder Journale sehen?", "a": "Nein. Fluent-Friend-Gespräche und Journaleinträge bleiben immer privat."},
  "personalVocab": {"q": "Kann meine Lehrkraft meinen persönlichen Wortschatz sehen?", "a": "Nein. Lehrkräfte sehen nur den Fortschritt bei Wörtern, die in ihrer Klasse zugewiesen wurden."},
  "joinWhat": {"q": "Was passiert, wenn ich einer FluentLoop-Klasse beitrete?", "a": "Die Klasse erscheint unter Meine Klassen, und die Aufgaben Ihrer Lehrkraft erscheinen dort und auf Ihrem Dashboard. Aus Ihrem persönlichen Konto wird nichts geteilt."},
  "personalAccount": {"q": "Kann ich mein persönliches FluentLoop-Konto weiter nutzen?", "a": "Ja. Alles in Ihrem Konto bleibt verfügbar, gemäß Ihrem normalen Konto und Tarif."},
  "findClass": {"q": "Wo finde ich meine Klasse?", "a": "Öffnen Sie Mehr → Meine Klassen. Jede Klasse zeigt Ihre Schule, Ihre Lehrkraft und Ihre Aufgaben."},
  "findAssignments": {"q": "Wo finde ich Aufgaben?", "a": "In jeder Klasse unter Meine Klassen. Offene Schularbeit erscheint außerdem als kleine Karte auf Ihrem Dashboard."},
  "inviteLink": {"q": "Was passiert, wenn ich auf einen Klassen-Einladungslink klicke?", "a": "Sie sehen Klasse und Schule und bestätigen den Beitritt. Wenn Sie noch nicht angemeldet sind, melden Sie sich zuerst an oder registrieren sich und kommen dann direkt zur Klasse zurück."},
  "multiClass": {"q": "Kann ich in mehreren Klassen sein?", "a": "Ja. Alle Ihre Klassen erscheinen unter Meine Klassen."},
  "leaveData": {"q": "Werden meine persönlichen FluentLoop-Daten gelöscht, wenn ich eine Klasse verlasse oder abschließe?", "a": "Nein. Ihre persönlichen FluentLoop-Daten bleiben in Ihrem Konto."},
  "pilotEnds": {"q": "Was passiert, wenn der Pilot abläuft?", "a": "Es kann keine neue Schularbeit erstellt werden: keine neuen Klassen, Aufgaben oder Missionen, und keine neuen Lernenden können beitreten. Nichts wird gelöscht, und der Zugang wird wieder aktiv, wenn der Pilot verlängert wird."},
  "finishAfter": {"q": "Können Lernende bestehende Aufgaben nach Ablauf abschließen?", "a": "Ja. Lernende, die bereits in einer Klasse sind, können Aufgaben abschließen, die vor Ende des Pilots gestellt wurden."},
  "dataAfter": {"q": "Was passiert nach Ablauf mit Klassen und Ergebnissen?", "a": "Sie bleiben einsehbar. Klassen, Listen, Aufgaben und Ergebnisse werden nicht gelöscht."},
  "studentPilotEnds": {"q": "Was passiert, wenn der Pilot meiner Schule endet?", "a": "Sie können Arbeit abschließen, die Ihre Lehrkraft bereits zugewiesen hatte. Ihr persönliches FluentLoop-Konto bleibt unverändert."}
 }
});
export default edu;
